module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","setYear"],"commonjs":"date-fns/set_year/index","commonjs2":"date-fns/set_year/index","amd":"date-fns/set_year/index"}
// module id = 50
// module chunks = 0